import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=02065d92"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02065d92')) {
      api.createRecord('02065d92', component.options)
    } else {
      api.reload('02065d92', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=02065d92", function () {
      api.rerender('02065d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Footer.vue"
export default component.exports